import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const RefineContainer = styled.div`
  padding: 16px;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varBackgroundAlt};
  border: 1px ${themeStyle.transparentBlack} solid;
`;

export const RefineImageContainer = styled.div<{ backgroundImage: string }>`
  position: relative;
  height: 82px;
  border-radius: ${themeStyle.radiusMedium};
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-size: cover;
  cursor: pointer;
`;

const overlayBackground = 'rgba(0, 0, 0, 0.5)';
const overlayHoverBackground = 'rgba(0, 0, 0, 0.6)';

export const RefineOverlay = styled(FlexColumn)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${overlayBackground};
  border-radius: ${themeStyle.radiusMedium};
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${overlayHoverBackground};
  }
`;
